<template>
  <div>
    <BCard v-if="errors && errors.length > 0" variant="danger" class="mb-3">
      <ul class="bookapp-errors">
        <li v-for="error in errors" :key="error">
          {{ error }}
        </li>
      </ul>
    </BCard>

    <p>
      {{ $t('components.payments.integrations.paypal.newWindow') }}
    </p>

    <UButton class="mt-3" size="lg" block :loading="loading" :disabled="disabled || loading" @click="process">
      <span v-if="loading">
        {{ $t('general.pleaseWait') }}
      </span>
      <span v-else>
        {{ confirmButtonTitle }}
      </span>
    </UButton>
  </div>
</template>

<script setup lang="ts">
const { $i18n } = useNuxtApp()

interface Props {
  confirmButtonTitle: string
  integration: any
  disabled: boolean
  action: Function
  callbackUrl: Function
  processExternal?: Function
}

const props = withDefaults(defineProps<Props>(), {
})

const emit = defineEmits(['callback'])

const loading = ref(false)
const errors = ref<string[]>([])
const approvalUrl = ref()
const interval = ref()

const linkTarget = computed(() => {
  return (window.self !== window.top) ? '_blank' : null
})

onBeforeUnmount(() => {
  clearInterval(interval.value)
})

onMounted(async () => {
  loading.value = true

  try {
    const url = await props.callbackUrl()
    const response = await props.action({ action: 'get-express-checkout', confirmUrl: url, cancelUrl: url })

    if (response.success) {
      if (!response.result || !response.result.approvalUrl) {
        errors.value.push('Issue loading PayPal service')
      } else {
        approvalUrl.value = response.result.approvalUrl
      }
    }
  } catch (error) {
    errors.value.push($i18n.t('general.errorPayment'))
  }

  loading.value = false
})

const process = () => {
  if (!props.processExternal) {
    return
  }

  props.processExternal(approvalUrl.value, 'height=400,width=500', ({ success, params, errors: _errors }) => {
    if (success) {
      emit('callback', { success, params, errors: _errors })
    } else {
      errors.value = _errors
    }
  })
}
</script>
